<template>
  <div class="col-md-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body" v-if="isLogged">
        <div class="row mb-4">
          <div class="col-md-6">
            <h3 class="font-weight-bold">Gestión de Menús</h3>
          </div>
          <div class="col-md-6"></div>
        </div>

        <!-- <div class="white-content-general mb-4">
          <div class="row">
            <div class="col-md-4">
              <p class="lh-m mb-0"></p>
            </div>
            <div class="col-md-8">
              <button
                @click="agregar"
                class="btn btn-general btn-primary float-right"
              >
                <span class="icon-plus"></span> Agregar
              </button>
            </div>
          </div>
        </div> -->
        <div class="white-content-table">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th width="5%"></th>
                  <th>Name</th>
                  <th>Path</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in menus" :key="item.id">
                  <td>

                    <a href="javascript:void(0)" @click="eliminar(item.id)"
                      ><i class="ti-trash btn-icon-append"></i
                    ></a>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.path }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OpcionesMenu",
  data() {
    return {};
  },
  created() {
    this.consultar();
  },
  methods: {
    loaderSpinner() {
      this.loader = this.$loading.show();
    },
    async consultar() {
      this.loaderSpinner();
      try {
        await this.$store.dispatch("menu/searchAllMenus");
      } catch (error) {
        alert("No se pudo realizar la consulta");
      } finally {
        this.loader.hide();
      }
    },
    async agregar() {
      await this.$store.commit("menu/setMenuSeleccionado", null);
      this.$router.push({ name: "MenuForm" });
    },
    async editar() {

    },
    async eliminar() {

    },
  },
  computed: {
    isLogged() {
      return this.$store.getters["auth/isLogged"]
        ? this.$store.getters["auth/isLogged"]
        : false;
    },
    menus() {
      return this.$store.getters["menu/menus"]
        ? this.$store.getters["menu/menus"]
        : [];
    },
  },
};
</script>
<style></style>
